import { defineMessages } from 'react-intl';

export default defineMessages({
    doingRateMessage: {
        id: 'quoteandbind.eh.views.riskAnalysis.Please wait while we rate your policy...',
        defaultMessage: 'Please wait while we rate your policy...'
    },
    lossesAndViolationTabHeading: {
        id: 'quoteandbind.eh.views.riskAnalysis.lossesAndViolation.Losses',
        defaultMessage: 'Losses'
    },
    miscellaneaousReportsTabHeading: {
        id: 'quoteandbind.eh.views.riskAnalysis.miscellaneaousReports.Miscellaneous Reports',
        defaultMessage: 'Miscellaneous Reports'
    },
    creditTabHeading: {
        id: 'quoteandbind.eh.views.riskAnalysis.credit.Credit',
        defaultMessage: 'Credit'
    }
});
